"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.generateCustomPackingSlipHTMLV1 = void 0;
const moment_1 = __importDefault(require("moment"));
const homi_shared_1 = require("@getgreenline/homi-shared");
const CreatePaymentLine_1 = require("@getgreenline/homi-shared/dist/models/Payments/CreatePaymentLine");
const packingSlipHelpers_1 = require("./packingSlipHelpers");
// NOTE: This is not using the new receipt settings
const generateCustomPackingSlipHTMLV1 = (packingSlipData, fontSize) => {
    const { company, customerPhone, deviceId, receiptSettings, payment } = packingSlipData;
    if (!payment) {
        return;
    }
    const companyName = company.name;
    const customerName = (0, packingSlipHelpers_1.getCustomerName)(payment);
    const receiptLocationNameText = receiptSettings.receiptLocationNameText;
    const receiptLocationDescriptionText = receiptSettings.receiptLocationDescriptionText;
    const receiptAddressText = receiptSettings.receiptAddressText;
    const completeDate = payment.status === homi_shared_1.PaymentQueueStatus.COMPLETED && payment.completedPayment
        ? payment.completedPayment.completeDate
        : null;
    const isPaid = 'completedPayment' in payment ? 'Paid' : 'Unpaid';
    const paymentData = {
        customId: (0, packingSlipHelpers_1.getCustomId)(payment),
        createDate: 'createDate' in payment ? payment.createDate : null,
        completeDate,
    };
    const receiptShowSku = receiptSettings.receiptShowSku;
    const paymentLines = payment.paymentLines;
    const notes = 'paymentQueueNotes' in payment && payment.paymentQueueNotes
        ? payment.paymentQueueNotes
        : payment.notes;
    return `
  <div id='print-section' style='padding-left: 10px; padding-right: 10px;'>
    <table 
      style='width: 100%;
      border: none;
      border-width: 0;
      border-collapse: collapse;
      padding: 0;
      ${fontSize ? 'font-size: ' + fontSize + ';' : ''}'
    >
      <tbody>
        <tr>
          <td colspan=2;>
            <b 
              style='font-size: 1.5em; 
              font-weight: 600;'
            >${companyName}</b>
          </td>
          <td style='text-align: right;'>
            <b>${isPaid}</b>
          </td>
        </tr>

        ${receiptLocationNameText
        ? `
              <tr>
                <td colspan=2>${receiptLocationNameText}</td>
              </tr>
              `
        : ''}

        ${receiptLocationDescriptionText
        ? `
              <tr>
                <td 
                  colspan=2;
                  style='margin-bottom: 20px;
                  white-space: pre-line;
                  overflow-wrap: break-word;
                  word-break: break-all'
                >${receiptLocationDescriptionText}</td>
              </tr>
              `
        : ''}

        ${receiptAddressText
        ? `
              <tr>
                <td colspan=2>${receiptAddressText}</td>
              </tr>
              `
        : ''}
      </tbody>
    </table>

    <table 
      style='margin-top: 1.5rem;
      width: 100%;
      border: none;
      border-width: 0;
      border-collapse: collapse;
      padding: 0;
      ${fontSize ? 'font-size: ' + fontSize + ';' : ''}'
    >
      <tbody>
        ${paymentData.customId
        ? `<tr>
                  <td style='border-top: solid; border-width: 1px; '>Order ID</td>
                  <td style='border-top: solid; border-width: 1px;  text-align: right'>${paymentData.customId}</td>
                </tr>`
        : ''}

        ${paymentData.completeDate
        ? `
                <tr>
                  <td style='border-top: solid; border-width: 1px;'>Completed</td>
                  <td style='border-top: solid; border-width: 1px; text-align: right'>
                    ${(0, moment_1.default)(paymentData.completeDate).format('lll')}
                  </td>
                </tr>
              `
        : `
                <tr>
                  <td style='border-top: solid; border-width: 1px; '>Created</td>
                  <td style='border-top: solid; border-width: 1px;  text-align: right'>
                    ${(0, moment_1.default)(paymentData.createDate).format('lll')}
                  </td>
                </tr>
              `}

        <tr>
          <td style='border-top: solid; border-width: 1px;'>POS</td>
          <td style='border-top: solid; border-width: 1px; text-align: right'>
            ${deviceId || '-'}
          </td>
        </tr>

        ${customerName
        ? `
                  <tr>
                    <td style='border-top: solid; border-width: 1px; '>Customer</td>
                    <td style='border-top: solid; border-width: 1px;  text-align: right'>${customerName}</td>
                  </tr>
                `
        : ''}

        ${customerPhone
        ? `
                  <tr>
                    <td style='border-top: solid; border-width: 1px; '>Phone #</td>
                    <td style='border-top: solid; border-width: 1px;  text-align: right'>${customerPhone}</td>
                  </tr>
                `
        : ''}
      </tbody>
    </table>

    <table 
      style='margin-top: 1.5rem;
      width: 100%;
      border: none;
      border-width: 0;
      border-collapse: collapse;
      padding: 0;
      ${fontSize ? 'font-size: ' + fontSize + ';' : ''}'
    >
      <tbody>
        <tr>
          <td><b>Product</b></td>
          <td style='text-align: right'><b>Qty</b></td>
          <td style='text-align: right'><b>Price</b></td>
        </tr>
        ${paymentLines
        .map((paymentLine) => {
        const { productId, productName } = paymentLine;
        const quantity = paymentLine instanceof homi_shared_1.CreatePaymentLine ||
            paymentLine instanceof CreatePaymentLine_1.CreateGiftCardPaymentLine
            ? paymentLine.units
            : paymentLine.quantity;
        if (!productId && productName) {
            return `
                  <tr>
                    <td style='border-top: solid; border-width: 1px;'>
                      <div class='d-flex' style='flex-direction: column;'>
                        <div>${paymentLine.productName}</div>
                        ${``}
                        ${paymentLine.discountMessage
                ? `<div style='font-size: .9em'>${paymentLine.discountMessage}</div>`
                : ``}
                      </div>
                    </td>
                    <td 
                      style='border-top: solid;
                      border-width: 1px;
                      padding-right:.5rem;
                      text-align: right'
                    >${quantity}</td>
                    <td 
                      style='border-top: solid;
                      border-width: 1px;
                      text-align: right'
                    >
                      ${paymentLine.discountPrice
                ? (0, homi_shared_1.formatCurrencyFromCents)(paymentLine.discountPrice * quantity)
                : '$0.00'}
                    </td>
                  </tr>
                `;
        }
        if (!productId)
            return;
        const unitString = quantity.toString();
        let price = 0;
        if (paymentLine instanceof homi_shared_1.CreatePaymentLine ||
            paymentLine instanceof CreatePaymentLine_1.CreateGiftCardPaymentLine) {
            price = paymentLine.pricePerUnit || 0;
        }
        else {
            price = (paymentLine.price || 0) / quantity;
        }
        if (paymentLine.discountPrice < 0 || paymentLine.discountPercentage > 0) {
            return `
                  <tr>
                    <td style='border-top: solid; border-width: 1px;'>
                      <div class='d-flex' style='flex-direction: column;'>
                        <div>${paymentLine.productName}</div>
                        ${receiptShowSku && paymentLine.sku
                ? `<div style='font-size:.8em'>SKU: ${paymentLine.sku}</div>`
                : ``}

                        ${paymentLine.discountMessage
                ? `<div style='font-size: .9em'>${paymentLine.discountMessage}</div>`
                : ``}
                      </div>
                    </td>

                    <td 
                      style='border-top: solid;
                      border-width: 1px;
                      padding-right:.5rem;
                      text-align: right'
                    >${unitString}</td>

                    <td 
                      style='border-top: solid;
                      border-width: 1px;
                      text-align: right'
                    >
                      ${paymentLine ? (0, homi_shared_1.formatCurrencyFromCents)(price * quantity) : '$0.00'}
                    </td>
                  </tr>

                  ${paymentLine.discountPrice &&
                `
                      <tr>
                        <td>${paymentLine.discountMessage
                    ? paymentLine.discountMessage
                    : `${(0, homi_shared_1.formatCurrencyFromCents)(Math.abs(paymentLine.discountPrice))} off`}</td>
                        <td></td>
                        <td style='text-align: right;'>${(0, homi_shared_1.formatCurrencyFromCents)(paymentLine.discountPrice)}</td>
                      </tr>
                      
                    `}
                `;
        }
        else {
            return `
                  <tr>
                    <td style='border-top: solid; border-width: 1px; '>
                      <div class='d-flex' style='flex-direction: column;'>
                        <div>${paymentLine.productName}</div>
                        ${receiptShowSku && paymentLine.sku
                ? `<div style='font-size:.8em'>SKU: ${paymentLine.sku}</div>`
                : ``}
                        ${paymentLine.discountMessage
                ? `<div style='font-size: .9em'>${paymentLine.discountMessage}</div>`
                : ``}
                      </div>
                    </td>

                    <td 
                      style='border-top: solid;
                      border-width: 1px;
                      padding-right:.5rem;
                      text-align: right'
                    >${unitString}</td>

                    <td 
                      style='border-top: solid;
                      border-width: 1px;
                      text-align: right'
                      >
                      ${paymentLine ? (0, homi_shared_1.formatCurrencyFromCents)(price * quantity) : '$0.00'}
                    </td>
                  </tr>

                  ${paymentLine.discountPrice
                ? `
                      <tr>
                        <td>${paymentLine.discountMessage}</td>
                        <td></td>
                        <td style='text-align: right;'> ${(0, homi_shared_1.formatCurrencyFromCents)(paymentLine.discountPrice)}</td>
                      </tr>
                    `
                : ''}
                  `;
        }
    })
        .join('')}
      </tbody>
    </table>

    <table 
      style='margin-top: 1.5rem;
      width: 100%;
      border: none;
      border-width: 0;
      border-collapse: collapse;
      padding: 0;
      ${fontSize ? 'font-size: ' + fontSize + ';' : ''}'
    >
      <tbody>
        ${notes
        ? `
                <tr>
                  <td><b>Notes</b></td>
                </tr>
                <tr>
                  <td 
                    colspan=2;
                    style='border-top: solid;
                    border-width: 1px;
                    margin-bottom: 20px;
                    white-space: pre-line;
                    overflow-wrap: break-word;
                    word-break: break-all'
                  >${notes}</td>
                </tr>
                `
        : ''}
      </tbody>
    </table>
  </div>
  `;
};
exports.generateCustomPackingSlipHTMLV1 = generateCustomPackingSlipHTMLV1;
//# sourceMappingURL=generatePackingSlipHTMLV1.js.map